import { Button, CircularProgress } from "@material-ui/core";

const MergeStopsActions = ({
  mergeStopInProgress,
  onClose,
  mergeCustomers,
  classes,
}) => {
  return (
    <div className={classes.footer}>
      <div className={classes.actionContainer}>
        <Button
          variant="outlined"
          color="primary"
          classes={{
            root: classes.actionButton,
            disabled: classes.actionDisabled,
          }}
          onClick={onClose}
          disabled={mergeStopInProgress}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={mergeStopInProgress}
          classes={{
            root: `${classes.actionButton} ${
              mergeStopInProgress ? classes.activePrimaryButton : ""
            }`,
            disabled: classes.actionDisabled,
          }}
          onClick={mergeCustomers}
        >
          {mergeStopInProgress ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Merge"
          )}
        </Button>
      </div>
    </div>
  );
};

export default MergeStopsActions;
